import Json from '../data/Jsonblob'
import {
  FETCH_DATA_BEGIN,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAILURE
} from './StatsActions';

const initialState = {
  allDate: [],
  data: [],
  countries: [],
  gender: [],
  age: [],
  sortedAgeByData: [],
  yearBound: [],
  toggleGender: '',
  all: false,
  loading: false,
  error: null,
  allCountries: [],
  allGenders: [],
  allAges: [],
  yearMin: null,
  yearMax: null,
  ageDataNumber: {},
  url: '',
  indicatorURL: '',
  yearToolTip: true,
  countryToolTip: true,
  countryAvailableYears: {}
}

function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

function sortData( data ){
  var allAges = []
  var allCountries = []
  var allGenders = []
  var allYear = []
  var ageDataNumber = {}
  var returnedData = {}
  var countryAvailableYears = {}
  data.forEach( document => {
    allAges.push(document.age);
    allCountries.push(document.country);
    allGenders.push(document.gender);
    allYear.push(document.sample_year);
    document.value = round(document.value, 1);
    document.value = parseFloat(document.value);
    if (countryAvailableYears.hasOwnProperty(document.country)){
      if(!countryAvailableYears[document.country].includes(document.sample_year)){
        countryAvailableYears[document.country].push(document.sample_year)
        countryAvailableYears[document.country].sort()
      }
    } else {
      countryAvailableYears[document.country] = [document.sample_year]
    }
    if (ageDataNumber.hasOwnProperty(document.age)){
      ageDataNumber[document.age] += 1;
    } else {
      ageDataNumber[document.age] = 1;
    }
  })
  allCountries.sort();
  returnedData['allAges'] = Array.from(new Set(allAges));
  returnedData['allCountries'] = Array.from(new Set(allCountries));
  returnedData['allGenders'] = Array.from(new Set(allGenders));
  returnedData['allYear'] = Array.from(new Set(allYear));
  returnedData['data'] = data.slice();
  returnedData['ageDataNumber'] = ageDataNumber;
  returnedData['countryAvailableYears'] = countryAvailableYears;
  return returnedData
}

function sortSelectedAge (arr, keys){
  var newObj = {};
  for (let i = 0; i < arr.length; i ++){
    newObj[arr[i]] =  keys[arr[i]]
  }
  var arr = [newObj]
  const sortedAgeByData = Object.keys(arr[0]).sort((a, b) => arr[0][b] - arr[0][a]);
  return sortedAgeByData;
}

function getURL(indicatorURL, gender, age, countries, yearBound){
  var gender = gender.join(',');
  var age = age.join(',');
  var countries = countries.join(',');
  var yearBound = yearBound.join(',');
  var newURL = `${indicatorURL}`.concat(`&gender=${gender}&age=${age}&countries=${countries}&yearBound=${yearBound}`)
  newURL = newURL.replace(/ /g, '%20');
  return newURL
}

function setDefault(params){
  var defaultVal = {};
  defaultVal.yearBound = params.yearBound.replace(/%2C/g, ',').split(',');
  for(let i = 0; i < 2; i ++ ){
    defaultVal.yearBound[i] = parseInt(defaultVal.yearBound[i])
  }
  defaultVal.gender = params.gender.replace(/%2C/g, ',').replace(/%20/g, ' ').split(',');
  defaultVal.age = params.age.replace(/\+|%20/g, ' ').replace(/%28/g, '(').replace(/%29/g, ')').replace(/%2C/g, ',').split(',');
  defaultVal.countries = params.countries.replace(/%2C/g, ',').replace(/%20/g, ' ').split(',');
  return defaultVal;
}

function defaultGenderSelect(gender){
  var returnGender = [gender[0]];
  gender.forEach( data => {
    if(data === 'Male' || data === 'male'){
        returnGender = [data]
    }
  })
  return returnGender
}

function reducer (state = initialState, action){
  switch(action.type)
  {
      case FETCH_DATA_BEGIN:
      var currentURL = window.location.href;
      if (currentURL.includes('?')){
        currentURL =  currentURL.substring(0, currentURL.lastIndexOf('/')+1);
      }
      var newURL = `${currentURL}selections?`.concat(`indicator=${action.payload}`);
      return {
        ...state,
        loading: true,
        indicatorURL: newURL,
        error: null
      };
      case FETCH_DATA_SUCCESS:
      var allAges = []
      var allData = []
      var allCountries = []
      var allGenders = []
      var allYear = []
      var gender = []
      var age = []
      var ageDataNumber = {}
      var sortedAgeByData = []
      var countries = []
      var yearBound = []
      var countryAvailableYears = {}

      var sortedData = sortData(action.payload.data.result)
      allAges = sortedData.allAges
      allCountries = sortedData.allCountries
      allGenders = sortedData.allGenders
      allYear = sortedData.allYear
      ageDataNumber = sortedData.ageDataNumber
      countryAvailableYears = sortedData.countryAvailableYears


      var yearMax = Math.max.apply(Math, allYear);
      var yearMin = Math.min.apply(Math, allYear);

      if(Object.keys(action.params).length !== 0){
        var defaultValues = setDefault(action.params);
        age = defaultValues.age;
        gender = defaultValues.gender;
        countries = defaultValues.countries;
        yearBound = defaultValues.yearBound;
        sortedAgeByData = sortSelectedAge( age.slice(), ageDataNumber );
      } else {
        gender = defaultGenderSelect(allGenders.slice());
        countries = allCountries.slice();
        yearBound = [yearMin, yearMax];
        sortedAgeByData = sortSelectedAge( allAges.slice(), ageDataNumber );
        age.push(sortedAgeByData[0]);
        sortedAgeByData = [sortedAgeByData[0]];

      }
      var url = getURL(state.indicatorURL, gender, sortedAgeByData, allCountries, [yearMin, yearMax])
      return {
        ...state,
        loading: false,
        allData: sortedData.data.slice(),
        data: sortedData.data.slice(),
        allCountries: allCountries,
        allAges: allAges,
        yearMax: yearMax,
        yearMin: yearMin,
        yearBound: yearBound,
        allGenders: allGenders,
        gender: gender,
        age: age,
        sortedAgeByData: sortedAgeByData,
        ageDataNumber: ageDataNumber,
        countries: countries,
        url: url,
        countryAvailableYears: countryAvailableYears
      };
    case 'CLEARFILTER':
      return { ...state,
              countries: [],
              age: [],
              gender: [],
              sortedAgeByData: []
             };
    case FETCH_DATA_FAILURE:
     return {
       ...state,
       loading: false,
       error: action.payload.error,
     };
     case 'ADDCOUNTRY':
       let countries = [];
       var newURL = "";
       if(action.value === 'All Countries'){
         countries = state.allCountries.slice();
        // newURL = getURL(gender, state.sortedAgeByData, countries, state.yearBound);
       } else {
         if(state.countries.length > 10){
           countries.push(action.value);
          // newURL = getURL(gender, state.sortedAgeByData, countries, state.yearBound);
         } else {
           countries = state.countries.slice();
           countries.push(action.value);
         }
       }
       newURL = getURL(state.indicatorURL, state.gender, state.sortedAgeByData, countries, state.yearBound);
       return { ...state, countries: countries, url: newURL };
     case 'DELETECOUNTRY':
        var countries = state.countries.filter(country => country !== action.value);
        var newURL = getURL(state.indicatorURL, state.gender, state.sortedAgeByData, countries, state.yearBound);
       return { ...state,  countries: countries, url: newURL };
     case 'ONCLICKGENDER':
        var gender = state.gender.slice();
        if(gender.includes(action.value)){
          gender = gender.filter( gender => gender !== action.value)
          var newURL = getURL(state.indicatorURL, gender, state.sortedAgeByData, state.countries, state.yearBound);
          return { ...state, gender: gender, url: newURL }
        } else {
          gender.push(action.value);
          var newURL = getURL(state.indicatorURL, gender, state.sortedAgeByData, state.countries, state.yearBound);
          return { ...state, gender: gender, url: newURL}
        }
      case 'ONCHANGEAGE':
        var age = state.age.slice();
        var sortedAgeByData = state.sortedAgeByData.slice();
        if(age.includes(action.value)){
          sortedAgeByData = sortedAgeByData.filter( age => age !== action.value);
          var newURL = getURL(state.indicatorURL, state.gender, sortedAgeByData, state.countries, state.yearBound)
          return { ...state,
            age: age.filter( age => age !== action.value),
            sortedAgeByData: sortedAgeByData,
            url: newURL }
        } else {
          age.push(action.value);
          sortedAgeByData.push(action.value);
          sortedAgeByData = sortSelectedAge( sortedAgeByData, state.ageDataNumber )
          var newURL = getURL(state.indicatorURL, state.gender, sortedAgeByData, state.countries, state.yearBound)
          return { ...state, age: age, sortedAgeByData: sortedAgeByData, url: newURL }
        }
      case 'ONCHANGEYEAR':
          var newURL = getURL(state.indicatorURL, state.gender, state.sortedAgeByData, state.countries, action.value)
          return { ...state, yearBound: action.value, url: newURL}
      case 'TOGGLEGENDER':
          return { ...state, toggleGender: action.value}
      case 'ONCLOSEYEARTOOLTIP':
          return { ...state, yearToolTip: false}
      case 'ONCLOSECOUNTRYTOOLTIP':
        return { ...state, countryToolTip: false}
  }

  return state;
}

export default reducer



// WEBPACK FOOTER //
// ./src/redux/StatsReducer.js